import { Injectable } from '@angular/core'
import { openWindow, ConfirmDialogService } from '@tokeet-frontend/tv3-platform'
import {
  DisconnectMessagingChannel,
  LoadMessagingChannelConfigs,
  MessagingChannelKeys,
  MessagingChannelsService,
} from '@tokeet-frontend/message'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { switchMap, tap } from 'rxjs/operators'

@Injectable()
export class MessagingChannelHelperService {
  constructor(
    private store: Store<any>,
    private confirm: ConfirmDialogService,
    private messagingChannelsService: MessagingChannelsService
  ) {}

  connect(channel: MessagingChannelKeys) {
    let observable: Observable<string>
    // Special handling for Facebook
    if (channel === 'facebook') {
      observable = this.confirm
        .confirmExtra({
          title: $localize`Is your Facebook page managed by a business account?`,
          body: $localize`If your Facebook page is managed through a business account, please check the box below.`,
          extra: $localize`My page is managed by a business account`,
          confirmText: $localize`Proceed`,
          cancelText: $localize`Cancel`,
        })
        .pipe(
          switchMap((result) => {
            // User made a choice (didn't close dialog)
            const type = result.isChecked ? 'business' : 'personal'
            return this.messagingChannelsService.loginChannel(channel, type)
          })
        )
    } else {
      // Original behavior for other channels
      observable = this.messagingChannelsService.loginChannel(channel)
    }

    const open = (url: string) => {
      return new Observable((ob) => {
        openWindow(
          url,
          () => {
            ob.next()
            ob.complete()
          },
          1000
        )
      })
    }

    return observable.pipe(
      switchMap((url) => open(url)),
      tap(() => this.store.dispatch(LoadMessagingChannelConfigs()))
    )
  }

  disconnect(channel: MessagingChannelKeys) {
    this.confirm
      .confirm({ title: $localize`Warning!`, body: $localize`Are you sure you want to disconnect this?` })
      .subscribe(() => {
        this.store.dispatch(DisconnectMessagingChannel({ channel }))
      })
  }
}
